var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"loaderBtn",attrs:{"type":"submit","disabled":""}},[_c('div',{staticClass:"item loading-6"},[_c('svg',{attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{style:(`stroke:${_vm.stroke};`),attrs:{"cx":"50","cy":"50","r":"20"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }